export default "__VITE_ASSET__1f53285d__"